import React from "react";
import "./Companies.css";
const Companies = () => {
  return (
    <section className="c-wrapper  ">
      <div className="paddings innerWidth flexCenter c-container">
        <img src="image/prologis.png" alt="logo" />
        <img src="image/tower.png" alt="logo" />
        <img src="image/equinix.png" alt="logo" />
        <img src="image/realty.png" alt="logo" />
      </div>
    </section>
  );
};

export default Companies;
